const UserRoundIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {},
  'data-testid': dataTestId
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
  'data-testid'?: string;
}) => {
  return (
    <span className={className} onClick={onClick} data-testid={dataTestId}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path
          fill='none'
          d='M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13ZM12 13C14.1217 13 16.1566 13.8429 17.6569 15.3431C19.1571 16.8434 20 18.8783 20 21M12 13C9.87827 13 7.84344 13.8429 6.34315 15.3431C4.84285 16.8434 4 18.8783 4 21'
        />
      </svg>
    </span>
  );
};

export default UserRoundIcon;
